import { DataSourceType } from 'automation-ui-formula-editor/data-passing-panel/types/dataSourcesTypes';
export const actionOutputsFilterAndSort = ({
  childrenDataSources = [],
  currentActionId,
  getActionHeaderTitle
}) => childrenDataSources.filter(childrenDataSource => {
  if (childrenDataSource.connectionType !== DataSourceType.ACTION_OUTPUT) {
    return false;
  }
  const metadata = childrenDataSource.metadata;
  const {
    actionId: childActionId
  } = metadata;
  return currentActionId.toString() !== childActionId.toString();
}).map(childActionOutput => {
  const metadata = childActionOutput.metadata;
  const {
    actionId: childActionId
  } = metadata;
  return {
    childActionOutput,
    actionTitle: getActionHeaderTitle({
      actionId: childActionId,
      useString: true
    })
  };
}).sort((a, b) => a.actionTitle.localeCompare(b.actionTitle, undefined, {
  numeric: true
})).map(childActionOutputWithTitle => childActionOutputWithTitle.childActionOutput);